import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BillPageRoutingModule } from './bill-routing.module';

import { BillPage } from './bill.page';
import { SharedComponentsModule } from '@1bill-app/components/shared-components.module';
import { PipesModule } from '@1bill-app/pipes/pipes.module';
import { BillAddressSearchModalComponent } from './components/bill-address-search-modal/bill-address-search-modal.component';
import { PopoverBetterDealTncComponent } from '@1bill-app/components/popover/popover-better-deal-tnc/popover-better-deal-tnc.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BillPageRoutingModule,
    SharedComponentsModule,
    PipesModule,
  ],
  declarations: [
    BillPage,
    BillAddressSearchModalComponent,
    PopoverBetterDealTncComponent,
  ],
})
export class BillPageModule {}
